import { Router } from "../router";

export const router = new Router<any>();

router.on("project_browser_sessions", (data, ctx) => {
    ctx.browser.syncSessions(data.sessions ?? []);
});

router.on("browser_session_state", (data, ctx) => {
    ctx.browser.syncSession(data);
});

router.on("browser_cursor_update", (data, ctx) => {
    ctx.browser.setCursor(data);
});

router.on("browser_network_request", (data, ctx) => {
    ctx.browser.addNetworkRequest(data);
});

router.on("browser_network_response", (data, ctx) => {
    ctx.browser.addNetworkResponse(data);
});

router.on("browser_network_body", (data, ctx) => {
    ctx.browser.addNetworkBody(data);
});

router.on("browser_network_failed", (data, ctx) => {
    ctx.browser.addNetworkFailed(data);
});

router.on("browser_console_entry", (data, ctx) => {
    ctx.browser.addConsoleEntry(data);
});

router.on("browser_console_result", (data, ctx) => {
    ctx.browser.addConsoleResult(data);
});
